"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var MinimalLoader_1 = require("../../../../../../common/components/presentation/MinimalLoader/MinimalLoader");
var useWidgetContext_1 = require("../../../../../../common/react/useWidgetContext");
var assetManager_1 = require("../../../../../../../../common/service/assetManager");
var constants_1 = require("../../../../../../common/constants/constants");
var errorHandler_1 = require("../../../../../common/service/errorHandler");
var payment_1 = require("../../../../../../common/constants/payment");
var Stripe = function (_a) {
    var dealStatus = _a.dealStatus;
    var widgetId = react_1.useMemo(function () { return 'dxp-payment-container' + Math.floor(Math.random() * 100); }, []);
    var widgetInstance = react_1.useRef(null);
    var paymentLibrary = react_1.useRef(null);
    var configuration = useWidgetContext_1.default().configuration;
    var _b = react_1.useState(false), isLoading = _b[0], setLoadingStatus = _b[1];
    var ensureLibraryLoaded = function () {
        var widgetUrl = payment_1.PAYMENT_CONFIG.dxpWidgetUrl;
        if (assetManager_1.assetManager.isScriptLoaded(widgetUrl)) {
            if (!paymentLibrary.current && window.DXPPayment) {
                paymentLibrary.current = window.DXPPayment;
            }
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(function () {
            // keep in mind there's a slight difference between the react versions of dxp and auto-widgets
            if (!assetManager_1.assetManager.isScriptLoaded(constants_1.default.REACT_DEPENDENCIES.react18)) {
                return assetManager_1.assetManager
                    .loadScript(constants_1.default.REACT_DEPENDENCIES.react18)
                    .then(function () { return assetManager_1.assetManager.loadScript(constants_1.default.REACT_DEPENDENCIES.reactDom18); });
            }
        })
            .then(function () { return assetManager_1.assetManager.loadScript(widgetUrl, 'module'); })
            .then(function () {
            paymentLibrary.current = window.DXPPayment;
        });
    };
    var getLibrary = react_1.useCallback(function () {
        if (!paymentLibrary.current) {
            throw new Error("Attempted to use DXP Payment library without loading it first");
        }
        return paymentLibrary.current;
    }, [paymentLibrary.current]);
    var initializeWidget = function () {
        if (widgetInstance.current) {
            widgetInstance.current.destroy();
        }
        setLoadingStatus(true);
        var widgetConfig = {
            containerId: widgetId,
            dimensions: configuration.dimensions,
            dealStatus: dealStatus,
        };
        var dxpWidget = getLibrary();
        dxpWidget.createWidget(widgetConfig);
    };
    react_1.useEffect(function () {
        if (!widgetInstance.current) {
            ensureLibraryLoaded()
                .then(function () { return initializeWidget(); })
                .catch(errorHandler_1.default.promise())
                .finally(function () { return setLoadingStatus(false); });
        }
        return function () {
            if (widgetInstance.current) {
                widgetInstance.current.destroy();
            }
        };
    }, []);
    return (<>
      {isLoading && <MinimalLoader_1.default />}
      <div id={widgetId} data-test="payment:stripe"/>
    </>);
};
exports.default = Stripe;
